import { Icon } from '@global-ecom/nitro-uds/elements';
import { useState } from 'react';

import { useSiteConfig } from 'hooks/useSiteConfig';
import Modal from 'ui/components/Modal';
import { SUPPORTED_COUNTRY } from 'utils/constants';
import { ManagedHeading } from 'ui/components/ManagedHeading';

import CloseButton from './CloseButton';
export const AfterpayInfo = () => {
  const [isOpen, setOpen] = useState(false);
  const { country } = useSiteConfig();

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="h-[24px] px-1.5 py-[9px] border-2 hover:(border-[#8C9198] border-2) border border-[#DFE0E1] rounded-sm flex items-center mx-1"
      >
        <Icon
          name="payment-afterpay-inline"
          label="Learn more about Afterpay"
          className="h-[24px]! w-[40px]!"
        />
      </button>

      {isOpen && (
        <Modal
          variant="dark"
          onClickOutside={() => {
            setOpen(false);
          }}
          className="max-w-md py-8 xs:px-6"
        >
          <CloseButton
            className="absolute top-5 right-5 !mt-0"
            onClick={() => {
              setOpen(false);
            }}
          />
          <div className="space-y-6 text-center flex flex-col items-center">
            <div className="bg-[#88fce3] px-2 py-1 rounded-full">
              <Icon name="payment-afterpay" size="10xl" aspectRatio={0.6} />
            </div>
            <ManagedHeading className="font-bold text-3xl" tag="h1">
              Shop Now, Pay Later.
              <br />
              Always interest-free.
            </ManagedHeading>
            <div className="px-6">
              <img
                aria-hidden
                src="/assets/afterpay-instructions.png"
                alt=""
                width="655"
                height="609"
              />
              <p className="sr-only">Add your favorites to cart. </p>
              <p className="sr-only">Select Afterpay at checkout. </p>
              <p className="sr-only">
                Log into or create your Afterpay account, with instant approval
                decision.
              </p>
              <p className="sr-only">
                Your purchase will be split into 4 payments, payable every 2
                week
              </p>
            </div>
            <div>
              {country === SUPPORTED_COUNTRY.US && (
                <>
                  <p className="text-xs mb-6">
                    You must be over 18, a resident of the U.S. and meet
                    additional eligibility criteria to qualify. Late fees apply.
                    Estimated payment amounts shown on product pages exclude
                    taxes and shipping charges, which are added at checkout.{' '}
                    <a
                      target="_blank"
                      referrerPolicy="no-referrer"
                      href="https://www.afterpay.com/installment-agreement"
                      className="underline"
                      rel="noreferrer"
                    >
                      {' '}
                      Click here for complete terms.
                    </a>
                  </p>
                  <p className="text-xs opacity-60">
                    Loans to California residents made or arranged pursuant to a
                    California Finance Lenders Law license.
                  </p>
                </>
              )}
              {country === SUPPORTED_COUNTRY.CA && (
                <>
                  <p className="text-xs">
                    You must be of the age of majority in your province or
                    territory, a resident of Canada, and meet additional
                    eligibility criteria to qualify. See{' '}
                    <a
                      target="_blank"
                      referrerPolicy="no-referrer"
                      href="https://www.afterpay.com/en-ca"
                      rel="noreferrer"
                    >
                      http://afterpay.com/en-ca
                    </a>{' '}
                    for more details.
                  </p>
                  <p className="text-xs">&copy; 2020 Afterpay Canada</p>
                </>
              )}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
